import { MswDataConfig } from 'app/mocks/utils/dataConfigUtils'
import { SponsormanStatus } from 'EstraSponsor'
import * as Yup from 'yup'

export type MswDevToolsFormData = {
  status: SponsormanStatus | null
}

export const mswDevToolsFormDefaultValues: MswDevToolsFormData = {
  status: null,
}

export const mswDevToolsFormValidationSchema = Yup.object().shape({
  status: Yup.string().nullable().required('Campo obbligatorio'),
})

export const adaptLocalStorageToFormData = (
  data: MswDataConfig
): MswDevToolsFormData => ({
  status: data.status as SponsormanStatus,
})

export const adaptFormDataToLocalStorage = (
  formData: MswDevToolsFormData
): MswDataConfig => ({
  status: formData.status as SponsormanStatus,
})
